import React, { useState } from "react";
import "./AddNoteFolder.css";
import { useLanguage } from "../../../../LanguageProvider";
import { IoCloseOutline } from "react-icons/io5";
import { TbApi, TbFolder } from "react-icons/tb";
import AddModalInputField from "../../../../components/AddModalInputField/AddModalInputField";
import { useToaster } from "../../../../ToasterProvider";

export default function AddNoteFolder({ isOpen, onClose, onCreate }) {
  const { toastWarning } = useToaster();
  const { getTranslation } = useLanguage();
  const [folderTitle, setFolderTitle] = useState("");

  if (!isOpen) return null;

  const handleCreate = () => {
    if (folderTitle.trim() === "") {
      toastWarning(getTranslation("folderNameCantBeEmpty"));
      return;
    }
    onCreate(folderTitle);
    onClose();
    setFolderTitle("");
  };

  return (
    <div className="add-request-modal-overlay">
      <div className="add-request-modal-container">
        <IoCloseOutline
          className="add-request-modal-button close"
          onClick={onClose}
        />

        <p className="add-request-modal-title">{getTranslation("addNewFolder")}</p>

        <AddModalInputField icon={<TbFolder size={22} style={{ width: "25px" }} />} placeholder={getTranslation("enterFolderName") + "*"} value={folderTitle} onChange={(e) => setFolderTitle(e.target.value)} type={"text"} />

        <div className="add-request-modal-actions">
          <button
            className="add-request-modal-button create"
            onClick={handleCreate}
          >
            {getTranslation("create")}
          </button>
        </div>
      </div>
    </div>
  );
}
